module.exports = __webpack_public_path__ + "img/whatsapp-plus-features-screenshot.6cfdf547.webp";